import { useEffect, useState, useCallback, createContext, useContext } from "react";
import axios from "axios";
import { useAuth } from "@/context/AuthContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const CollectionCtx = createContext({ items: [], lookup: () => null, reload: () => {} });

/**
 * Loads the current user's release collection once and exposes a
 * fast `lookup(kind, id)` to render Collection-Badges everywhere
 * (covers, modal, leaderboard) without re-fetching per card.
 */
export function CollectionProvider({ children }) {
  const { user } = useAuth();
  const [items, setItems] = useState([]);
  const reload = useCallback(async () => {
    if (!user?.email) { setItems([]); return; }
    try {
      const { data } = await axios.get(`${API}/release-collection/me`);
      setItems(data || []);
    } catch { /* ignore */ }
  }, [user?.email]);
  useEffect(() => { reload(); }, [reload]);
  const lookup = useCallback(
    (kind, id) => items.find((x) => x.release_kind === kind && x.release_id === id) || null,
    [items]
  );
  return (
    <CollectionCtx.Provider value={{ items, lookup, reload }}>
      {children}
    </CollectionCtx.Provider>
  );
}

export function useReleaseCollection() {
  return useContext(CollectionCtx);
}
